import { loadOptions } from '../formset.js';
import { REGEX, replaceIndex } from '../table.js';
import db from '../db.js';

// Requires observer.js
export default function (...args)	// store, { value: '', labels: [], separator: '' }, extra_key, range
{
	
	let SHARED = { _this: null };	// Create a new object each time the function is called, ie when the type is being defined

	return {

		_store: args[0],									// DB store name (eg: 'companies')
		_value: args[1]?.value || 'id',						// Property that will become the <option value=""> (eg: 'id')
		_labels: args[1]?.labels || ['name'],				// Properties that will become the <option>label</option> (eg: ['name'])
		_separator: args[1]?.sep,							// Optional character to join array-like label values (eg: '-')
		_filter: args[1]?.filter,							// Optional filter function (record) => boolean
		_key: args[1]?.key,									// Optional extra key to list the db data (eg: 'company_id')
		_range: args[1]?.range,								// Index for the range used to retrieve db data (0=upper/lower bound, 1=single value)
		_index: args[1]?.index,								// Number of index to use when retrieving db data (1 or 2)
		/** Saídas multi-armazém: id de posição não é global — value = `warehouse_id:location_id`, label com prefixo do armazém */
		_compositeWhLoc: Boolean(args[1]?.compositeWhLoc),

		async actions(ev, publisher, key)
		{
			const fmtLocAddr = (a) => (Array.isArray(a) ? a.join('-') : String(a ?? ''));
			const action = async (keys) =>
			{
				let range;
				// Saídas multi-armazém: linhas podem referenciar armazéns ≠ do cabeçalho; não restringir IDB ao `warehouse_id` do publisher.
				// Índice IDB `locations-1` = (company_id, warehouse_id, **id**). O índice `locations-2` usa **address** no 3º campo —
				// o intervalo antigo [wh, '', '\uffff'] não percorria as posições corretamente → datalist incompleto e campo mostrando "5:5937".
				if (this._compositeWhLoc && this._store === 'locations' && keys.length === 1)
				{
					const c = keys[0];
					const MAX_WH = 2147483647;
					const MAX_ID = 2147483647;
					range = IDBKeyRange.bound([c, 0, 0], [c, MAX_WH, MAX_ID]);
				}
				else
				{
					let base_key = this._key ? [''] : '';
					let top_key = this._key ? ['\uffff'] : '\uffff';
					range = this._range ? IDBKeyRange.only([...keys]) : IDBKeyRange.bound([...keys, base_key], [...keys, top_key]);
				}
				const idbIndex = (this._compositeWhLoc && this._store === 'locations')
					? 1
					: (this._index ?? 2);
				let data = await db.list(this._store, range, idbIndex);
				if (this._filter) data = (data || []).filter(this._filter);
				if (this._compositeWhLoc && this._store === 'locations')
				{
					// Se o cursor não trouxe a linha já selecionada (ex.: limite de leitura / corrida), inclui pela chave primária.
					const companyId = keys[0];
					let selVal = '';
					try {
						selVal = String(this.getValue?.() ?? '').trim();
					} catch (_) { /* noop */ }
					if (!selVal) {
						const el = document.querySelector(this.selector);
						if (el)
							selVal = String(el.value || '').trim();
					}
					const parsed = /^(\d+):(\d+)$/.exec(selVal);
					if (parsed && companyId != null && companyId !== '')
					{
						const wh = Number(parsed[1]);
						const lid = Number(parsed[2]);
						const exists = (data || []).some((loc) =>
							String(loc.company_id) === String(companyId)
							&& Number(loc.warehouse_id) === wh
							&& Number(loc.id) === lid);
						if (!exists)
						{
							try {
								const one = await db.get('locations', [companyId, wh, lid]);
								if (one)
									data = [...(data || []), one];
							} catch (_) { /* IDB indisponível */ }
						}
					}
					data = (data || []).map((loc) => ({
						...loc,
						_wh_loc: `${loc.warehouse_id}:${loc.id}`,
						_loc_label: fmtLocAddr(loc.address),
					}));
					loadOptions(this.selector, data, '_wh_loc', ['_loc_label']);
				}
				else
					loadOptions(this.selector, data, this._value, this._labels, this._separator);
				this.refresh();
			}
			let keys = [!isNaN(key) && !Array.isArray(key) ? Number(key) : key];
			if (this._key)
			{
				if (this.getId().match(REGEX) && this._key.match(REGEX))
					this._key = replaceIndex(this._key, this.getId().match(REGEX).pop());
				let val = this.locate(this._key)?.getValue();
				// sessionStorage retorna strings; IndexedDB usa números em chaves compostas (company_id, etc.)
				keys.unshift(typeof val === 'string' && /^\d+$/.test(val) ? Number(val) : val);
			}
			if (this._compositeWhLoc && this._store === 'locations' && this._key && keys.length >= 1)
			{
				const companyVal = keys[0];
				keys = companyVal != null && companyVal !== '' ? [companyVal] : [];
			}
			// Só carrega se nenhuma chave for null/undefined/vazia (IDBKeyRange não aceita chaves inválidas)
			if (keys.length && keys.every(k => k != null && k !== '' && (typeof k === 'string' || (typeof k === 'number' && !isNaN(k) && k >= 0))))
				this.preventMultiCalls(SHARED, action, () => this.refresh(), keys);
		}

	};

}

